import React from 'react';
import Banner from './Banner';


export default () => (
    <div>
        <Banner/>
    </div>
)